module.exports = __webpack_public_path__ + "img/badge-list-thumb-097.d3c31a7d.png";